<!-- <div class="alert alert-warning">Repeating Section</div> -->
<!-- <div>shouldHide$ => {{shouldHide$ | async}}</div> -->

<div class="mb-3" *ngIf="!(shouldHide$ | async)">

    <ng-container *ngIf="!(numItems$ | async) && (schemaHasConfirmIfNoItems$ | async) && (schemaConfirmIfNoItemsMessage$ | async)">
        <div><mat-checkbox (change)="onConfirmChanged($event)" [(ngModel)]="confirmedNoItemsForForm">{{schemaConfirmIfNoItemsMessage$ | async}}</mat-checkbox></div>
    </ng-container>

    <ng-container *ngIf="!confirmedNoItemsForForm">
        <ng-container *ngIf="numItems$ | async">
            <div *ngFor="let f2 of field.fieldGroup; let i = index" class="row absolute-parent align-items-baseline">
                <formly-field class="col" [field]="f2" [options]="lgvFormSvc.formlyOptions$ | async"></formly-field>
                <!-- <div class="col-1 d-flex align-items-center trash-can"> -->
                <div class="upper-right">
                    <a (click)="onRemove(i)"><fa-icon icon="trash"></fa-icon></a>
                </div>
            </div>
        </ng-container>
    
        <div style="margin:30px 0;">
            <a (click)="onAdd()"><fa-icon icon="plus"></fa-icon> {{ props.addText }}</a>
        </div>
    </ng-container>

</div>